import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { SchematizedTileComponentItem, StickyType } from "./types"
import type {
    SchematizedData,
    SchematizedLayoutDeleteData,
    SchematizedPage,
    SchematizedPageGroup,
    SchematizedSaveData,
    SchematizedSize,
    SchematizedTile,
} from "../../../../graphql/types"

export const SCHEMATIZED_AGENDA_MOUNTED = "schematized/mounted"
export const schematizedAgendaMounted = () => ({
    type: SCHEMATIZED_AGENDA_MOUNTED,
})

export const FETCH_SCHEMATIZED_DATA_REQUESTED = "schematized/fetchDataRequested"

export const schematizedFetchDataRequested = () => ({
    type: FETCH_SCHEMATIZED_DATA_REQUESTED,
})

export const SCHEMATIZED_SAVE_SUCCESS = "schematized/save/success"

export const schematizedSaveSuccess = () => ({
    type: SCHEMATIZED_SAVE_SUCCESS,
})

export const SCHEMATIZED_SAVE_FAILURE = "schematized/save/failure"

export const schematizedSaveFailure = () => ({
    type: SCHEMATIZED_SAVE_FAILURE,
})
// Tile reducer actions

export const ADD_SCHEMATIZED_TILE = "schematized/addTile"

export const addSchematizedTile = (tileData: SchematizedTile, gridId: string) => ({
    type: ADD_SCHEMATIZED_TILE,
    payload: {
        gridId: gridId,
        tileData: tileData,
    },
})

export const UPDATE_SCHEMATIZED_TILE = "schematized/updateTile"

export const updateSchematizedTile = (tileId: string, tileData: Partial<SchematizedTile>) => ({
    type: UPDATE_SCHEMATIZED_TILE,
    payload: {
        tileId: tileId,
        tileData: tileData,
    },
})

export const DELETE_SCHEMATIZED_TILE = "schematized/deleteTile"

export const deleteSchematizedTile = (tileId: string) => ({
    type: DELETE_SCHEMATIZED_TILE,
    payload: {
        tileId: tileId,
    },
})
// Grid reducer actions

export const ADD_SCHEMATIZED_GRID = "schematized/addGrid"

export const addSchematizedGrid = (gridData: SchematizedPage, groupId: string) => ({
    type: ADD_SCHEMATIZED_GRID,
    payload: {
        groupId: groupId,
        gridData: gridData,
    },
})

export const DELETE_SCHEMATIZED_GRID = "schematized/deleteGrid"

export const deleteSchematizedGrid = (gridId: string) => ({
    type: DELETE_SCHEMATIZED_GRID,
    payload: {
        gridId: gridId,
    },
})
// Group reducer actions

export const UPDATE_SCHEMATIZED_GRID_GROUP = "schematized/updateGridGroup"

export const updateSchematizedGridGroup = (groupId: string, groupData: Partial<SchematizedPageGroup>) => ({
    type: UPDATE_SCHEMATIZED_GRID_GROUP,
    payload: {
        groupId: groupId,
        groupData: groupData,
    },
})

export const DELETE_SCHEMATIZED_GRID_GROUP = "schematized/deleteGridGroup"

export const deleteSchematizedGridGroup = (groupId: string) => ({
    type: DELETE_SCHEMATIZED_GRID_GROUP,
    payload: {
        groupId: groupId,
    },
})

export const UPDATE_SCHEMATIZED_GROUPS = "schematized/updateSchematizedGroups"

export const updateSchematizedGroups = (newSchematizedGroups: SchematizedPageGroup[]) => ({
    type: UPDATE_SCHEMATIZED_GROUPS,
    payload: {
        newSchematizedGroups: newSchematizedGroups,
    },
})
// Layout reducer actions

export const ADD_SCHEMATIZED_LAYOUT = "schematized/addLayout"

export const addSchematizedLayout = (layout: SchematizedData) => ({
    type: ADD_SCHEMATIZED_LAYOUT,
    payload: {
        layout: layout,
    },
})

export const UPDATE_SCHEMATIZED_LAYOUT = "schematized/updateLayout"

export const updateSchematizedLayout = (layoutId: string, layoutData: Partial<SchematizedData>) => ({
    type: UPDATE_SCHEMATIZED_LAYOUT,
    payload: {
        layoutId: layoutId,
        layoutData: layoutData,
    },
})

export const DELETE_SCHEMATIZED_LAYOUT = "schematized/deleteLayout"

export const deleteSchematizedLayout = (layoutId: string) => ({
    type: DELETE_SCHEMATIZED_LAYOUT,
    payload: {
        layoutId: layoutId,
    },
})
// Ui actions

export const ADD_NEW_SCHEMATIZED_TILE_REQUESTED = "schematized/addNewTileRequested"

export const addNewSchematizedTileRequested = (newTile: SchematizedTileComponentItem) => ({
    type: ADD_NEW_SCHEMATIZED_TILE_REQUESTED,
    payload: {
        newTile: newTile,
    },
})

export const MOVE_SCHEMATIZED_TILE_REQUESTED = "schematized/moveTile/requested"

export const moveSchematizedTileRequested = (tileId: string, x: number, y: number, gridId: string) => ({
    type: MOVE_SCHEMATIZED_TILE_REQUESTED,
    payload: {
        tileId: tileId,
        gridId: gridId,
        x: x,
        y: y,
    },
})

export const DELETE_SCHEMATIZED_TILE_REQUESTED = "schematized/deleteTileRequested"

export const deleteSchematizedTileRequested = (tileId: string, targetPageGroupId: Maybe<string>) => ({
    type: DELETE_SCHEMATIZED_TILE_REQUESTED,
    payload: {
        tileId: tileId,
        targetPageGroupId: targetPageGroupId,
    },
})

export const MARK_TILE_AS_STICKY_CLICKED = "schematized/markAsStickyClicked"

export const markTileAsStickyClicked = (tile: SchematizedTileComponentItem, stickyType: Maybe<StickyType>) => ({
    type: MARK_TILE_AS_STICKY_CLICKED,
    payload: {
        tile: tile,
        stickyType: stickyType,
    },
})

export const ADD_NEW_PAGE_REQUESTED = "schematized/addNewPageRequested"

export const schematizedAddNewPageRequested = () => ({
    type: ADD_NEW_PAGE_REQUESTED,
})

export const DELETE_CURRENT_PAGE_REQUESTED = "schematized/deleteCurrentPage"

export const schematizedDeleteCurrentPageRequested = () => ({
    type: DELETE_CURRENT_PAGE_REQUESTED,
})

export const SCHEMATIZED_UPDATE_PAGES_REQUESTED = "schematized/updatePagesRequested"

export const schematizedUpdatePagesRequested = (newPages: SchematizedPage[]) => ({
    type: SCHEMATIZED_UPDATE_PAGES_REQUESTED,
    payload: {
        newPages: newPages,
    },
})

export const SCHEMATIZED_SAVE_BUTTON_CLICKED = "schematized/save/clicked"

export const schematizedSaveButtonClicked = () => ({
    type: SCHEMATIZED_SAVE_BUTTON_CLICKED,
})

export const SCHEMATIZED_SAVE_MUTATION_REQUESTED = "schematized/saveMutationRequested"

export const schematizedSaveMutationRequested = (saveData: SchematizedSaveData) => ({
    type: SCHEMATIZED_SAVE_MUTATION_REQUESTED,
    payload: {
        saveData: saveData,
    },
})

export const SCHEMATIZED_LAYOUT_DELETE_MUTATION_REQUESTED = "schematized/deleteLayoutMutationRequested"

export const schematizedLayoutDeleteMutationRequested = (deleteData: SchematizedLayoutDeleteData) => ({
    type: SCHEMATIZED_LAYOUT_DELETE_MUTATION_REQUESTED,
    payload: {
        deleteData: deleteData,
    },
})

export const SCHEMATIZED_CANCEL_BUTTON_CLICKED = "schematized/cancel/clicked"

export const schematizedCancelButtonClicked = () => ({
    type: SCHEMATIZED_CANCEL_BUTTON_CLICKED,
})

export const RESET_SCHEMATIZED_STATE = "schematized/reset/state"

export const resetSchematizedState = () => ({
    type: RESET_SCHEMATIZED_STATE,
})

export const ENTER_FOLDER_CLICKED = "schematized/enterFolderClicked"

export const enterFolderClicked = (gridId: string) => ({
    type: ENTER_FOLDER_CLICKED,
    payload: {
        gridId: gridId,
    },
})

export const SCHEMATIZED_GRID_SELECTED = "schematized/displayedGridSelected"

export const schematizedGridSelected = (gridId: Maybe<string>) => ({
    type: SCHEMATIZED_GRID_SELECTED,
    payload: {
        gridId: gridId,
    },
})

export const SCHEMATIZED_LAYOUT_SELECTED = "schematized/displayedLayoutSelected"

export const schematizedLayoutSelected = (layoutId: Maybe<string>) => ({
    type: SCHEMATIZED_LAYOUT_SELECTED,
    payload: {
        layoutId: layoutId,
    },
})

export const SCHEMATIZED_SEARCH_CLICKED = "schematized/search/clicked"

export const schematizedSearchClicked = (searchKey: Maybe<string>) => ({
    type: SCHEMATIZED_SEARCH_CLICKED,
    payload: {
        searchKey: searchKey,
    },
})

export const SCHEMATIZED_RESOLUTION_CHANGED = "schematized/resolution/changed"

export const schematizedResolutionChanged = (size: SchematizedSize) => ({
    type: SCHEMATIZED_RESOLUTION_CHANGED,
    payload: {
        size: size,
    },
})
// Tab buttons

export const ADD_NEW_TAB_CLICKED = "schematized/addNewTabClicked"

export const schematizedAddNewTabClicked = () => ({
    type: ADD_NEW_TAB_CLICKED,
})

export const DELETE_TAB_CLICKED = "schematized/deleteTabClicked"

export const schematizedDeleteTabClicked = () => ({
    type: DELETE_TAB_CLICKED,
})
// Tab Renaming

export const SCHEMATIZED_LAYOUT_RENAME_VALUE_CHANGED = "schematized/renameLayoutValueChanged"

export const schematizedRenameLayoutValueChanged = (value: string) => ({
    type: SCHEMATIZED_LAYOUT_RENAME_VALUE_CHANGED,
    payload: {
        value: value,
    },
})

export const SCHEMATIZED_LAYOUT_RENAME_CLICKED = "schematized/renameLayoutRenameClicked"

export const schematizedRenameLayoutClicked = () => ({
    type: SCHEMATIZED_LAYOUT_RENAME_CLICKED,
})

export const SCHEMATIZED_LAYOUT_RENAME_CONFIRMED = "schematized/renameLayoutRenameConfirmed"

export const schematizedRenameLayoutConfirmed = () => ({
    type: SCHEMATIZED_LAYOUT_RENAME_CONFIRMED,
})

export const SCHEMATIZED_LAYOUTS_RESORTED = "schematized/layoutsResorted"

export const schematizedLayoutsResorted = (layoutIdxA: number, layoutIdxB: number) => ({
    type: SCHEMATIZED_LAYOUTS_RESORTED,
    payload: {
        layoutIdxA: layoutIdxA,
        layoutIdxB: layoutIdxB,
    },
})

export const SCHEMATIZED_LAYOUT_RENAME_RESET = "schematized/renameLayoutRenameReset"

export const schematizedRenameLayoutValueReset = () => ({
    type: SCHEMATIZED_LAYOUT_RENAME_RESET,
})
// Custom folder

export const CLOSE_CUSTOM_FOLDER_FORM_CLICKED = "schematized/customFolderForm/close/clicked"

export const closeCustomFolderFormClicked = () => ({
    type: CLOSE_CUSTOM_FOLDER_FORM_CLICKED,
})

export const UPDATE_CUSTOM_FOLDER = "schematized/update/customFolder"

export const updateCustomFolder = (tile: SchematizedTileComponentItem) => ({
    type: UPDATE_CUSTOM_FOLDER,
    payload: {
        tile: tile,
    },
})
// Fetching

export const FETCH_SCHEMATIZED_SUCCESS = "fetchSchematized/success"

export const fetchSchematizedSuccess = (schematizedLayouts: SchematizedData[]) => ({
    type: FETCH_SCHEMATIZED_SUCCESS,
    payload: {
        schematizedLayouts: schematizedLayouts,
    },
})

export const FETCH_SCHEMATIZED_FAILURE = "fetchSchematized/failure"

export const fetchSchematizedFailure = (error: any) => ({
    type: FETCH_SCHEMATIZED_FAILURE,
    payload: {
        error: error,
    },
})
